import React from "react";

import Input, { type InputProps } from "@admin/components/Input";

type Props = InputProps & {
    publicUrl?: string;
};

export default function PublicUrlInput({ publicUrl, label = `URL страницы`, ...props }: Props) {
    const canOpen = Boolean(publicUrl && /^https?:\/\//i.test(publicUrl));

    return (
        <div className="d-flex align-items-end gap-2 mb-5">
            <Input
                {...props}
                label={label}
                aria-label={label}
                className={{ block: `flex-grow-1 mb-0` }}
            />
            {canOpen && (
                <a
                    href={publicUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-light-primary mb-2 flex-shrink-0"
                    title="Открыть сохранённую страницу в новой вкладке"
                    aria-label="Открыть сохранённую страницу в новой вкладке"
                >
                    Перейти <i className="bi bi-box-arrow-up-right ms-1" aria-hidden="true" />
                </a>
            )}
        </div>
    );
}
